import { render, staticRenderFns } from "./HeadTabBar.vue?vue&type=template&id=62bece5d&scoped=true&"
import script from "./HeadTabBar.vue?vue&type=script&lang=js&"
export * from "./HeadTabBar.vue?vue&type=script&lang=js&"
import style0 from "./HeadTabBar.vue?vue&type=style&index=0&id=62bece5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bece5d",
  null
  
)

export default component.exports